<template>
  <DataGetter
    @dataAvailable="
      data => {
        categories = data?.metaData?.categories
      }
    "
    contentId="categories"
  />
  <DataGetter
    @dataAvailable="
      data => {
        appInfo = data?.metaData
      }
    "
    contentId="appInfo"
  />
  <DataGetter
    @dataAvailable="
      data => {
        products = data
        if (this.isEditing) this.findSelectedProduct()
      }
    "
    contentId="products"
  />
  <form @submit.prevent="submitForm">
    <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
      <!-- Section Catégorie -->
      <div
        class="md:col-span-2 border bg-white rounded-3xl p-4"
        v-if="!isEditing"
      >
        <h1 class="text-lg font-bold title-color">Recherche du produit</h1>
        <div class="py-2"></div>
        <InputComponent
          label="Catégorie du produit"
          type="select"
          :options="
            categories.map(option => {
              return `${option.name}`
            })
          "
          required
          v-model="selectedCategory"
        />

        <InputComponent
          v-if="subcategories[0]"
          label="Sous Catégorie"
          type="select"
          :options="
            subcategories.map(option => {
              return `${option.name}`
            })
          "
          required
          v-model="selectedSubCategory"
        />

        <FormComponent
          v-if="selectedSubCategory"
          :fields="[
            {
              type: 'select',
              propertyName: 'product',
              options: productOptions,
              formatOptionInputDisplay(option) {
                return `${option.name}`
              },
              formatOptionsDisplay(option) {
                return `${option.name}`
              },
              onChanged(product) {
                selectedProduct = product
              },
              inputProps: {},
              required: true,
              label: 'Produit',
            },
          ]"
        >
          <template #submitButton> <div></div> </template>
        </FormComponent>
      </div>
      <div class="md:col-span-2 border bg-white rounded-3xl p-4" v-else>
        <h1 class="text-lg font-bold title-color">Produit</h1>
        <div class="py-2"></div>
        <InputComponent
          label="Produit sélectionné"
          type="text"
          disabled
          v-model="selectedProduct.name"
        />
      </div>
      <div
        class="md:col-span-2 border bg-white rounded-3xl p-4"
        :class="{
          'pointer-events-none saturate-0 !bg-slate-100 opacity-50':
            !selectedProduct.id,
        }"
      >
        <h1 class="text-lg font-bold title-color">Configuration du deal</h1>
        <div class="py-2"></div>
        <InputComponent
          label="Réduction"
          type="number"
          suffix="%"
          min="0"
          max="100"
          placeHolder="Appliquer une réduction"
          v-model="formData.discount"
        />

        <InputComponent
          label="Début"
          type="date"
          required
          v-model="formData.startDate"
          disabled
        />

        <InputComponent
          label="Fin"
          type="date"
          required
          :inputProperties="{ min: formData.startDate }"
          v-model="formData.endDate"
        />
      </div>
    </div>

    <div class="py-4"></div>
    <div v-if="selectedProduct">
      <div class="text-center">
        Montant original:
        <span class="line-through">
          {{ selectedProduct.price || 0 }} FCFA
        </span>
      </div>
      <div class="text-center">
        Montant réduit:
        <span class="fon-bold title-color">
          {{
            selectedProduct.price -
              (selectedProduct.price * (formData.discount || 0)) / 100 || 0
          }}
          FCFA
        </span>
      </div>
    </div>
    <div class="py-4"></div>
    <div class="flex justify-center">
      <button type="submit" class="buttonComponent">
        {{ isEditing ? 'Mettre à jour' : 'Ajouter' }}
      </button>
    </div>
    <div class="pb-12"></div>
  </form>
</template>

<script>
import { defineComponent } from 'vue'
import InputComponent from '../utils/InputComponent.vue'
import DataGetter from '../utils/DataGetter.vue'
import FormComponent from '../utils/FormComponent.vue'
import moment from 'moment'

export default defineComponent({
  name: 'DealForm',
  components: {
    InputComponent,
    DataGetter,
    FormComponent,
  },
  props: {
    initialData: {
      type: Object,
      default: () => ({
        id: '',
        discount: 0,
        inPercent: true,
        isActive: true,
        productData: {},
        productId: '',
        startDate: Date.now(),
        endDate: Date.now() + 24 * 60 * 60 * 1000,
        storeId: '',
      }),
    },
    isEditing: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      categories: [],
      selectedCategory: '',
      selectedSubCategory: '',
      formData: {
        ...this.initialData,
        startDate: this.$Commons.time(this.initialData.startDate, 'YYYY-MM-DD'),
        endDate: this.$Commons.time(this.initialData.endDate, 'YYYY-MM-DD'),
      },
      selectedProduct: {},
    }
  },
  methods: {
    findCategoryByName(categoryName) {
      return this.categories.find(category => category.name == categoryName)
    },
    findSelectedProduct() {
      console.log(this.formData)
      console.log(this.formData.productData)
      console.log(this.products)
      this.selectedProduct =
        this.products.find(
          product => product.id == this.formData.productData.id,
        ) || {}
    },
    submitForm() {
      const data = {
        ...this.formData,
        productData: JSON.parse(
          JSON.stringify(this.selectedProduct.rawProduct),
        ),
        productId: this.selectedProduct.id,
        discount: this.formData.discount,
        startDate:
          moment(this.formData.startDate)
            .set('h', 0)
            .set('minute', 0)
            .set('s', 0)
            .unix() * 1000,
        endDate:
          moment(this.formData.endDate)
            .set('h', 23)
            .set('minute', 59)
            .set('s', 59)
            .unix() * 1000,
      }
      this.$emit('dealSubmitted', data)
    },
  },
  computed: {
    categoryId() {
      const categoryFound = this.findCategoryByName(this.selectedCategory)
      return categoryFound?.id || ''
    },
    subcategories() {
      const categoryFound = this.findCategoryByName(this.selectedCategory)
      return categoryFound?.subcategories || []
    },
    subcategoryId() {
      return (
        this.subcategories.find(sub => sub.name == this.selectedSubCategory)
          ?.id || ''
      )
    },
    productOptions() {
      if (!this.subcategoryId) return []
      return (this.products || []).filter(
        product =>
          product.categoryId == this.categoryId &&
          product.subcategoryId == this.subcategoryId,
      )
    },
  },
})
</script>

<style scoped></style>
